<script lang="ts">

  import { getContext } from "svelte";
  import BtnControl from "./BtnControl.svelte";
  import Icon, { type IconType } from "./Icon.svelte";
  import { ConnectMapApp } from "./app";
  import { derived, get, type Readable } from "svelte/store";
  import { type UI as Layout } from './UI.svelte';
  export let float = false;

  const app = getContext<ConnectMapApp<any>>('app');
  const { is_desktop, state, search_term, src_poi, dst_poi, T } = app;

  $: route_title = `${$src_poi?.label} -> ${$dst_poi?.label}`;

  const layout = getContext<Readable<Layout>>('ui_layout')

  $: ui = $layout.topbar
  $: static_text = ui.text;
  
</script>

<div class="topbar" class:float class:borderless={!ui.input} on:keyup >
  <BtnControl chromeless on:click={ui.btn1.action}>
    <Icon name={ui.btn1.icon} />
  </BtnControl>

  {#if ui.input}
    <input class="topbar__field"
      bind:value={$search_term}
      on:focus
      type="text" placeholder={$T`search`} />
  {:else if static_text}
    <div class="topbar__title">{@html $static_text}</div>
  {/if}


  {#if ui.btn2}
    <BtnControl chromeless on:click={ui.btn2.action}>
      <Icon name={ui.btn2.icon} />
    </BtnControl>
  {/if}
</div>

<style lang="scss">
  .topbar {
    box-sizing: border-box;
    flex-grow: 1;
    height: 50px;
    transform: translateY(0);
    transition: all .2s;

    display: flex;
    align-items: center;

    background-color: var(--_bg-1st);
    border: 1px solid var(--_topbar-border-c);
    border-radius: var(--vgwv-topbar--borderRadius, 4px);
    box-shadow: var(--vgwv-shadow-off);
    pointer-events: all;
    z-index: 10;

    view-transition-name: top-bar;

    &.topbar--space-exit {
      width: calc(100% - 48px - var(--vgwv-p8) * 3);
    }
  }

  .topbar.float {
    box-shadow: var(--vgwv-shadow-down);
    border-color: #fff;
  }

  .topbar.borderless {
    border-color: var(--_bg-1st);
  }

  @media (max-width: 767px) {
    .topbar.topbar--show {
      transform: translateY(calc(100% + var(--vgwv-p8)));
      box-shadow: var(--vgwv-shadow-down);
    }
  }

  @media (min-width: 768px) {
    .topbar {
      position: relative;
      top: var(--vgwv-p8);
    }
  }

  .topbar__title,
  .topbar__field {
    max-width: calc(100% - 96px);
    margin: 0;
    padding: 0;
    flex-grow: 1;
    border: none;
    font-size: inherit;
  }

  .topbar__title {
    display: flex;
    justify-content: space-around;

    & > :global(*) {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .topbar__field {
    height: 100%;
    background: var(--vgwv-topbar--backgroundColor, #fff);

    &:focus {
      outline: none;
    }

    &::-ms-clear { /* HM-4469 */
      display: none;
    }
  }
</style>